import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  payment_reference_control: {
    [LanguagesEnum.English]: 'Payment Reference',
    [LanguagesEnum.Greek]: 'Payment Reference',
  },
  reimbursement_date_control: {
    [LanguagesEnum.English]: 'Date of Reimbursement',
    [LanguagesEnum.Greek]: 'Date of Reimbursement',
  },
  vat_amount_to_be_reimbursed_control: {
    [LanguagesEnum.English]: 'Reimburse Amount',
    [LanguagesEnum.Greek]: 'Reimburse Amount',
  },
  iban_control: {
    [LanguagesEnum.English]: 'IBAN',
    [LanguagesEnum.Greek]: 'IBAN',
  },
  bic_control: {
    [LanguagesEnum.English]: 'BIC Code',
    [LanguagesEnum.Greek]: 'BIC Code',
  },
  submit: {
    [LanguagesEnum.English]: 'Submit',
    [LanguagesEnum.Greek]: 'Submit',
  },
};

export default CONFIGURATION;
